import CSVGeral from "./CSVGeral"

const typeImports = [CSVGeral]

export default typeImports